import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { icons } from "../../assets/icons"
import { InitialsIconProps } from "./props"
import { InitialsIconContainer } from "./styled"

const InitialsIcon = ({
  iconName,
  color,
  size,
  lastNameLetter,
  firstNameLetter,
}: InitialsIconProps) => {
  const Icon = icons[iconName as keyof typeof icons]
  const iconColor = color || "inherit"
  const iconSize = size || 24

  return (
    <Box sx={{ position: "relative", height: size }}>
      <Icon stroke={iconColor} width={iconSize} height={iconSize} />
      <Typography sx={InitialsIconContainer} variant="h4" color="initial">
        {lastNameLetter}
        {firstNameLetter}
      </Typography>
    </Box>
  )
}

export default InitialsIcon
